import React from 'react';
const bonuses = [{
  num: '01',
  title: 'Nutrición para el Desarrollo Cerebral',
  desc: 'Qué comer en cada etapa para potenciar el neurodesarrollo.',
  price: '$12.000'
}, {
  num: '02',
  title: 'Guía de Sueño Reparador',
  desc: 'Rutinas y protocolos para que tu hijo duerma bien.',
  price: '$9.000'
}, {
  num: '03',
  title: 'Kinesiología en Casa',
  desc: 'Ejercicios para estimular el desarrollo motor sin equipamiento.',
  price: '$10.000'
}, {
  num: '04',
  title: 'Control de Esfínteres Sin Stress',
  desc: 'Método paso a paso para acompañar esta etapa sin presión.',
  price: '$9.000'
}, {
  num: '05',
  title: 'Primeros Auxilios para Madres',
  desc: 'Qué hacer, cuándo actuar y cuándo ir al médico.',
  price: '$8.000'
}, {
  num: '06',
  title: 'Flashcards Imprimibles de Estimulación',
  desc: '60 tarjetas listas para actividades de estimulación cognitiva y visual.',
  price: '$10.000'
}];
export function Bonuses() {
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(255,255,255) 0%, rgb(255,255,255) 15%, rgb(255,255,255) 85%, rgb(254,242,242) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-44">
      <div className="mx-auto max-w-4xl" data-id="element-45">
        <h2 className="text-3xl font-black text-center text-gray-900 m-0 mb-2" data-id="element-46">
          Más los <span className="text-green-700" data-id="element-47">6 Bonos Exclusivos</span>
        </h2>
        <p className="text-center text-sm text-gray-500 m-0 mb-8" data-id="element-48">
          Incluidos en todas las ofertas — sin costo extra
        </p>

        <div className="bg-white border border-green-700/20 rounded-xl overflow-hidden shadow-sm mb-6" data-id="element-49">
          <div className="bg-green-700 px-5 py-3" data-id="element-50">
            <h3 className="text-sm font-black text-white m-0 tracking-wide" data-id="element-51">
              🎁 LOS 6 BONOS — Incluidos siempre
            </h3>
          </div>
          <div className="divide-y divide-gray-100" data-id="element-52">
            {bonuses.map(bonus => <div key={bonus.num} className="flex items-center gap-4 px-5 py-3" data-id="element-53">
                <span className="shrink-0 text-lg font-black text-green-700/30 w-8 text-center" data-id="element-54">
                  {bonus.num}
                </span>
                <div className="flex-1 min-w-0" data-id="element-55">
                  <span className="block text-sm font-black text-gray-900" data-id="element-56">
                    {bonus.title}
                  </span>
                  <span className="block text-xs text-gray-500 mt-0.5" data-id="element-57">
                    {bonus.desc}
                  </span>
                </div>
                <div className="shrink-0 flex flex-col items-end gap-0.5" data-id="element-58">
                  <span className="text-[10px] text-gray-400 line-through" data-id="element-59">
                    {bonus.price}
                  </span>
                  <span className="text-[10px] font-black text-white bg-green-700 rounded-full px-2 py-0.5" data-id="element-60">
                    GRATIS
                  </span>
                </div>
              </div>)}
          </div>
        </div>

        <div className="text-center rounded-xl px-5 py-4 shadow-sm" style={{
        backgroundColor: 'rgb(240, 253, 244)',
        border: '1px solid rgba(34, 197, 94, 0.3)'
      }} data-id="element-61">
          <p className="text-xs font-bold uppercase tracking-widest text-green-700 m-0 mb-1" data-id="element-62">
            Valor total de los 6 Bonos
          </p>
          <div className="flex items-center justify-center gap-3" data-id="element-63">
            <span className="text-base text-gray-400 line-through" data-id="element-64">$58.000</span>
            <span className="text-lg font-black text-green-700" data-id="element-65">
              🎁 GRATIS — Incluidos siempre
            </span>
          </div>
        </div>
      </div>
    </section>;
}